import { CreateUserDto } from "../../../core/models/dtos/CreateUserDto";
import { CreateUserBody } from "../bodies/CreateUserBody";

export function mapFromCreateUserDto(dto: CreateUserDto): CreateUserBody {
  return {
    firstName: dto.firstname,
    lastName: dto.lastname,
    email: dto.email,
    phone: dto.phone,
    organizationId: dto.organizationId,
    // Only when the caller decided (flag customerOnboardingEnabled): an
    // undefined field is left out of the body entirely, so every existing
    // caller still sends exactly the five fields of today.
    ...(dto.ccPrimaryContact !== undefined
      ? { ccPrimaryContact: dto.ccPrimaryContact }
      : {}),
  };
}
